import { render, staticRenderFns } from "./PosMenu.vue?vue&type=template&id=79076357&"
import script from "./PosMenu.vue?vue&type=script&lang=js&"
export * from "./PosMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports